import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CreditService } from '@app/shared/services/credit.service';

import {
  getPendingBalance,
  setCryptoInfo,
  setPendingBalanceAction,
  setTopUpPaymentMethodAction,
} from '@app/wallet/store/wallet.actions';
import { filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { TopUpMethodType } from '@app/wallet/models/top-up-method.type';
import { getTopUpAmount } from '@app/wallet/store/wallet.selectors';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class WalletEffects {
  private readonly creditService = inject(CreditService);
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);

  getUserPendingBalance$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getPendingBalance),
      switchMap(() => this.creditService.getPending()),
      map((result) => setPendingBalanceAction({ pendingBalance: result }))
    )
  );

  getCryptoInfo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setTopUpPaymentMethodAction),
      filter((payload) => payload.paymentMethod === TopUpMethodType.Crypto),
      withLatestFrom(this.store.select(getTopUpAmount)),
      switchMap((payload) => this.creditService.getCryptoInfo(payload[1])),
      map((cryptoInfo) => setCryptoInfo({ cryptoInfo }))
    )
  );
}
